export default __webpack_public_path__ + "static/media/board_football.68071ead.svg";